import { useState } from "react";
import { Accordion, Icon } from "semantic-ui-react";
import { ICalculation } from "../../../models/calculation";
import { raoReportSecuredOptions } from "../../../store/raoReportReducer";

const formatBoolean = (opt: boolean) => {
    if (opt) return "Yes";
    else return "No";
};

const formatRaoReportF299Secured = (opt: number) => {
    return raoReportSecuredOptions.filter(x => x.key === opt)[0].text;
};

interface IProps {
    calculation: ICalculation;
}

export const CalcPropsRAOReport = ({ calculation }: IProps) => {
    const [open, setOpen] = useState(false);

    return (
        <Accordion id="accordion-CalcPropsRAOReport-a">
            <Accordion.Title id="accordionTitle-CalcPropsRAOReport-a" active={open} index={0} onClick={() => setOpen(!open)}>
                <Icon id="icon-CalcPropsRAOReport-a" name="dropdown" />
                RAO Report
            </Accordion.Title>
            <Accordion.Content id="accordionContent-CalcPropsRAOReport-a" active={open}>
                <p id="p-CalcPropsRAOReport-a">
                    <label id="label-CalcPropsRAOReport-a">F299 secured:&nbsp;</label>
                    {formatRaoReportF299Secured(calculation.raoReport.f299Secured)}
                </p>
                <p id="p-CalcPropsRAOReport-b">
                    <label id="label-CalcPropsRAOReport-b">F299 non-secured:&nbsp;</label>
                    {formatBoolean(calculation.raoReport.f299NonSecured)}
                </p>
                <p id="p-CalcPropsRAOReport-c">
                    <label id="label-CalcPropsRAOReport-c">R1:&nbsp;</label>
                    {formatBoolean(calculation.raoReport.r1)}
                </p>
                <p id="p-CalcPropsRAOReport-d">
                    <label id="label-CalcPropsRAOReport-d">R2:&nbsp;</label>
                    {formatBoolean(calculation.raoReport.r2)}
                </p>
                <p id="p-CalcPropsRAOReport-e">
                    <label id="label-CalcPropsRAOReport-e">R3 secured:&nbsp;</label>
                    {formatBoolean(calculation.raoReport.r3Secured)}
                </p>
                <p id="p-CalcPropsRAOReport-f">
                    <label id="label-CalcPropsRAOReport-f">R3 non-secured:&nbsp;</label>
                    {formatBoolean(calculation.raoReport.r3NonSecured)}
                </p>
                <p id="p-CalcPropsRAOReport-g">
                    <label id="label-CalcPropsRAOReport-g">
                        R3 Print RAO Selection Result - Objective for each iteration:&nbsp;
                    </label>
                    {formatBoolean(calculation.raoReport.raoSelectionResultObjective)}
                </p>
                <p id="p-CalcPropsRAOReport-h">
                    <label id="label-CalcPropsRAOReport-h">R3 All NECs:&nbsp;</label>
                    {formatBoolean(calculation.raoReport.r3AllNecs)}
                </p>
                <p id="p-CalcPropsRAOReport-i">
                    <label id="label-CalcPropsRAOReport-i">R4:&nbsp;</label>
                    {formatBoolean(calculation.raoReport.r4)}
                </p>
                <p id="p-CalcPropsRAOReport-j">
                    <label id="label-CalcPropsRAOReport-j">R5:&nbsp;</label>
                    {formatBoolean(calculation.raoReport.r5)}
                </p>
                <p id="p-CalcPropsRAOReport-k">
                    <label id="label-CalcPropsRAOReport-k">IVA value justification:&nbsp;</label>
                    {!!calculation.raoReport.justification
                        ? calculation.raoReport.justification
                        : "None selected"}
                </p>
                <p id="p-CalcPropsRAOReport-l">
                    <label id="label-CalcPropsRAOReport-l">Include Reporting Information in IVA:&nbsp;</label>
                    {formatBoolean(calculation.raoReport.includeReportingInfoInIva)}
                </p>
                <p id="p-CalcPropsRAOReport-m">
                    <label id="label-CalcPropsRAOReport-m">RAO Inf/UnBd Fallback:&nbsp;</label>
                    {formatBoolean(calculation.raoReport.infUnBdFallback)}
                </p>
                <p id="p-CalcPropsRAOReport-n">
                    <label id="label-CalcPropsRAOReport-n">GROM_OPTIMIZER data:&nbsp;</label>
                    {formatBoolean(calculation.raoReport.gromOptimizerData)}
                </p>
                <p id="p-CalcPropsRAOReport-o">
                    <label id="label-CalcPropsRAOReport-o">Keep sensitivities data:&nbsp;</label>
                    {formatBoolean(calculation.raoReport.keepSensitivitiesData)}
                </p>
            </Accordion.Content>
        </Accordion>
    );
};
